import { useMemo } from "react";
import { uiNotification } from "../../../../../services/UINotificationService";
import { useClinicsObOrderQuery } from "../../../../../api/queries/useClinicsObOrderQuery";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";

export function useClinics() {
  const { tSettings } = useAppTranslation.Settings();

  const { data, isLoading } = useClinicsObOrderQuery({
    options: {
      onError: () => {
        uiNotification.error(tSettings("clinics.obOrder.error.fetch"));
      },
    },
  });

  const clinics = useMemo(
    () =>
      data?.map((i) => ({
        id: i.id,
        content: i.name,
      })) || [],
    [data],
  );

  return {
    clinics,
    isClinicsLoading: isLoading,
  };
}
